"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataAdapter = exports.configSchema = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _simpleFeature = _interopRequireDefault(require("@jbrowse/core/util/simpleFeature"));

var _configuration = require("@jbrowse/core/configuration");

var _io = require("@jbrowse/core/util/io");

var _BaseAdapter2 = require("./BaseAdapter");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var configSchema = (0, _configuration.ConfigurationSchema)('CytobandAdapter', {
  cytobandLocation: {
    type: 'fileLocation',
    defaultValue: {
      uri: '/path/to/cytoband.txt.gz'
    }
  }
}, {
  explicitlyTyped: true
});
exports.configSchema = configSchema;

var CytobandAdapter = /*#__PURE__*/function (_BaseAdapter) {
  (0, _inherits2.default)(CytobandAdapter, _BaseAdapter);

  var _super = _createSuper(CytobandAdapter);

  function CytobandAdapter() {
    (0, _classCallCheck2.default)(this, CytobandAdapter);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(CytobandAdapter, [{
    key: "getData",
    value: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var loc, data;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loc = (0, _configuration.readConfObject)(this.config, 'cytobandLocation');

                if (!(loc.uri === '' || loc.uri === '/path/to/cytoband.txt.gz')) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", []);

              case 3:
                _context.next = 5;
                return (0, _io.openLocation)(loc).readFile('utf8');

              case 5:
                data = _context.sent;
                return _context.abrupt("return", data.split('\n').filter(function (f) {
                  return !!f.trim();
                }).map(function (line) {
                  var _line$split = line.split('\t'),
                      _line$split2 = (0, _slicedToArray2.default)(_line$split, 5),
                      refName = _line$split2[0],
                      start = _line$split2[1],
                      end = _line$split2[2],
                      name = _line$split2[3],
                      type = _line$split2[4];

                  return new _simpleFeature.default({
                    uniqueId: line,
                    refName: refName,
                    start: +start,
                    end: +end,
                    name: name,
                    type: type
                  });
                }));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }()
  }, {
    key: "freeResources",
    value: function freeResources() {}
  }]);
  return CytobandAdapter;
}(_BaseAdapter2.BaseAdapter);

exports.DataAdapter = CytobandAdapter;